export const VALIDATION_MESSAGES = {
  required: 'validationMessages.required',
  passwordNotMatch: 'validationMessages.passwordNotMatch',
  invalidEmail: 'validationMessages.invalidEmail',
  invalidLink: 'validationMessages.invalidLink',
  minMax: 'validationMessages.minMax',
  passwordComplexity: 'validationMessages.passwordComplexity',
  maxlength: 'validationMessages.maxlength',
};
